<template>
  <div>
    <v-dialog fullscreen v-model="dialog" eager scrollable max-width="900px">
      <v-form ref="JobAppFormRef" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span class="text-uppercase" :class="action == 1 ? '' : 'd-none'"
              >List of Applicants for the position of {{ JobName }}</span
            >
            <span class="text-uppercase" :class="action == 2 ? '' : 'd-none'"
              >List of Hired Applicants for the position of {{ JobName }}</span
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-row>
              <v-col cols="12" md="6" class="mb-2">
                <v-tabs v-model="activeTab" color="#147452" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-col cols="12" md="6" class="mb-2">
                <v-text-field
                  v-model="search"
                  outlined
                  prepend-inner-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  class="rounded-lg"
                  color="#147452"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              :search="search"
              :headers="tab == 3 ? header1 : header"
              :items="jobApplicantData"
            >
              <template v-slot:[`item.birth`]="{ item }">
                {{ formatDate(item.birth) }}
              </template>
              <template v-slot:[`item.short_listed`]="{ item }">
                <div class="d-flex justify-center" style="padding: 4px;">
                  <v-checkbox
                    :input-value="tab === 2 ? true : item.short_listed"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    dense
                    @change="addedToShortList(item)"
                  />
                </div>
              </template>
              <!-- <template v-slot:[`item.attended_examination`]="{ item }">
                <div class="d-flex justify-center" style="padding: 4px;">
                  <v-checkbox
                    v-model="item.attended_examination"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    dense
                    readonly
                    @click="addedToShortList(item)"
                  />
                </div>
              </template> -->

              <template v-slot:[`item.list`]="{ item }">
                <v-chip
                  small
                  outlined
                  color="green"
                  @click="viewListedPositions(appliedPositionIDs[item.id || 1])"
                  style="cursor: pointer"
                >
                  {{ appliedCounts[item.id] || 1 }}
                </v-chip>
              </template>
              <template v-slot:[`item.fullname`]="{ item }">
                {{ toTitleCase(item.fullname) }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div class="text-no-wrap" style="padding: 4px;">
                  <v-btn
                    v-if="tab == 4"
                    x-small
                    class="white--text my-2 rounded-lg"
                    :class="action == 1 ? '' : 'd-none'"
                    color="orange"
                    @click="hireApplicant(item)"
                  >
                    <v-icon left> mdi-plus-box-outline </v-icon>
                    Hire
                  </v-btn>
                  <v-btn
                    x-small
                    class="white--text my-2 rounded-lg"
                    color="#147452"
                    @click="viewUserData(item)"
                  >
                    <v-icon left> mdi-eye-outline </v-icon>
                    View
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              v-if="
                (tab == 1 && addedToShortListData.length > 0) ||
                  (tab == 2 && removeToShortListData.length > 0)
              "
              color="#147452"
              variant="flat"
              class="white--text"
              min-width="100"
              @click="saveShortListed()"
            >
              <v-icon left>{{
                tab == 1 ? "mdi-content-save" : "mdi-delete"
              }}</v-icon>
              {{ tab == 1 ? "Save" : "Remove" }}
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              v-if="action == 'Add'"
              @click="addnew()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Add
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              v-if="action == 'Update'"
              @click="update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog fullscreen v-model="dialog2" eager scrollable max-width="900px">
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>{{ action }} Applicant</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD1()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0 pt-2 px-4">
                <iframe :src="text"></iframe>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" max-width="350">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">Please Confirm of Hiring</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              {{ applicantFullname }} for the position of: <br /><br />{{
                JobName
              }}
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
            Are you sure you want to proceed?
          </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="confirmDialog = false">
            Close
          </v-btn>
          <v-btn
            :color="$vuetify.theme.themes.light.submitBtns"
            class="white--text"
            @click="confirmHiring()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPositions" max-width="520">
      <v-card rounded="xl" elevation="8">
        <!-- Header -->
        <v-card-title class="d-flex align-center dialog-header gap-3 pa-6 pb-4">
          <!-- <v-avatar color="primary" size="40">
            <v-icon icon="mdi-account-tie" size="22" color="white" />
          </v-avatar> -->
          <div>
            <div class="text-h6 font-weight-bold">Applied Positions</div>
          </div>
          <v-spacer />
          <v-btn
            icon="mdi-close"
            variant="text"
            size="small"
            @click="dialogPositions = false"
          />
        </v-card-title>

        <v-divider />

        <!-- Body -->
        <v-card-text class="pa-6">
          <template v-if="positionsData && positionsData.length">
            <!-- Count badge -->
            <div class="d-flex align-center mb-4">
              <v-chip color="primary" size="small" variant="tonal">
                <v-icon start icon="mdi-briefcase-outline" size="14" />
                {{ positionsData.length }} Position{{
                  positionsData.length > 1 ? "s" : ""
                }}
              </v-chip>
            </div>

            <!-- Timeline list -->
            <div
              v-for="(item, index) in positionsData"
              :key="index"
              class="position-item d-flex align-start gap-3 mb-3"
            >
              <!-- Timeline dot + line -->
              <div
                class="d-flex flex-column align-center"
                style="min-width: 20px;"
              >
                <div
                  class="rounded-circle bg-primary"
                  style="width: 10px; height: 10px; margin-top: 5px; flex-shrink: 0;"
                />
                <div
                  v-if="index < positionsData.length - 1"
                  class="bg-grey-lighten-2"
                  style="width: 2px; flex: 1; min-height: 24px; margin-top: 4px;"
                />
              </div>

              <!-- Content card -->
              <v-card
                variant="tonal"
                color="surface-variant"
                rounded="lg"
                class="flex-grow-1 mb-1"
                style="padding: 10px 14px;"
              >
                <div
                  class="text-body-2 font-weight-semibold text-high-emphasis"
                >
                  {{ item.position }}
                </div>
                <div class="d-flex align-center gap-1 mt-1">
                  <v-icon
                    icon="mdi-calendar-outline"
                    size="12"
                    color="medium-emphasis"
                  />
                  <span class="text-caption text-medium-emphasis">{{
                    formatDate(item.appliedDate)
                  }}</span>
                </div>
              </v-card>
            </div>
          </template>

          <!-- Empty state -->
          <div v-else class="d-flex flex-column align-center pa-6 text-center">
            <v-icon
              icon="mdi-briefcase-off-outline"
              size="48"
              color="grey-lighten-1"
              class="mb-3"
            />
            <div class="text-body-1 font-weight-medium text-medium-emphasis">
              No positions found
            </div>
            <div class="text-caption text-disabled mt-1">
              This applicant has no position data.
            </div>
          </div>
        </v-card-text>

        <!-- Footer -->
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            color="error"
            variant="flat"
            rounded="medium"
            min-width="100"
            @click="dialogPositions = false"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MyJobApplication :data="JobApplicantData" :action="action" />
    <!-- confirmation dialog -->
    <v-dialog
      v-model="confirmSubmitShortListedDialog"
      persistent
      max-width="390"
    >
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">
            {{ tab == 1 ? "INFO!" : "WARNING!" }}
          </div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" :color="tab == 1 ? 'blue' : 'red'">{{
                tab == 1 ? "mdi-information" : "mdi-alert-circle"
              }}</v-icon>
              &nbsp; Are you sure you want to
              {{
                tab == 1
                  ? "add and proceed applicant to shortlist?"
                  : "remove applicant from shortlist?"
              }}
            </p>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            outlined
            @click="confirmSubmitShortListedDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :color="$vuetify.theme.themes.light.submitBtns"
            :loading="btnLoading"
            :disabled="btnLoading"
            class="white--text"
            @click="submitShortListed()"
          >
            Yes, I'm sure
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <LoadingState :show="loadingState" />
    </div>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="5000"
    ></fade-away-message-component>
  </div>
</template>

<script>
import LoadingState from "../../Alerts/LoadingState.vue";
export default {
  props: {
    data: null,
    action: null,
  },
  components: {
    MyJobApplication: () => import("./MyJobApplicationDialog.vue"),
    LoadingState,
  },
  data() {
    return {
      header: [
        {
          text: "Fullname",
          value: "fullname",
          align: "start",
          valign: "center",
        },

        {
          text: "Email",
          value: "email",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Phone no.",
          value: "phone_number",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Gender",
          value: "sogie_value",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Birth Date",
          value: "birth",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Add to Shortlist",
          value: "short_listed",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Applied Position/s",
          value: "list",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          sortable: false,
        },
      ],
      confirmDialog: false,
      loadingState: false,
      dialogPositions: false,
      JobApplicantData: null,
      positionsData: null,
      search: "",
      appliedCounts: {},
      appliedPositionIDs: {},
      activeTab: { id: 1, name: "Applicants" },
      tab: 1,
      tabList: [
        { id: 1, name: "Applicants" },
        { id: 2, name: "Shortlisted(HR)" },
        { id: 3, name: "Shortlisted(PSB)" },
      ],

      header1: [
        {
          text: "Fullname",
          value: "fullname",
          align: "start",
          valign: "center",
        },

        {
          text: "Email",
          value: "email",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Phone no.",
          value: "phone_number",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Gender",
          value: "sogie_value",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Birth Date",
          value: "birth",
          align: "center",
          valign: "center",
          sortable: false,
        },

        // {
        //   text: "Attended Examination",
        //   value: "attended_examination",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },

        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          sortable: false,
        },
      ],
      JobName: null,
      jobApplicantData: [],
      position: [],
      postedJob: [],
      positionID: null,
      text: "",
      show: false,
      id: null,
      dialog: false,
      dialog2: false,
      specialOrderNo: null,
      schoolYearFrom: null,
      schoolYearTo: null,
      positionname: null,
      confirmSubmitShortListedDialog: false,
      sem: null,
      countedPositionData: null,
      isActive: null,
      syList: [],
      addedToShortListData: [],
      removeToShortListData: [],
      tapTimePartID: null,
      designationList: [],
      officeList: [],

      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      applicantFullname: null,
      applicantFullData: [],
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        if (data.id) {
          this.JobName = data.position_title;
          this.show = 1;
          this.id = data.id;
          this.specialOrderNo = data.specialOrderNo;
          this.isActive = data.isActive ? "Active" : "Inactive";
          this.initialize();
        } else {
          this.$refs.JobAppFormRef.reset();
          this.initialize();
          this.units = 0;
          this.specialOrderNo = null;
          this.isActive = null;
        }
      },
      deep: true,
    },
  },

  methods: {
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
      this.addedToShortListData = [];
      this.removeToShortListData = [];
    },
    viewUserData(item) {
      this.JobApplicantData = item;
      this.action = "View";
    },
    addedToShortList(item) {
      if (this.tab == 1) {
        const index = this.jobApplicantData.findIndex((i) => i.id === item.id);

        if (index !== -1) {
          this.$set(this.jobApplicantData[index], "short_listed", 1);
        }
        console.log(item);
        if (item.short_listed == 1) {
          if (this.addedToShortListData.includes(item.id)) {
            this.addedToShortListData = this.addedToShortListData.filter(
              (id) => id !== item.id,
            );
          } else {
            this.addedToShortListData.push(item.id);
          }
        } else {
          const index = this.addedToShortListData.indexOf(item.id);
          if (index > -1) {
            this.addedToShortListData.splice(index, 1);
          }
        }
      } else if (this.tab == 2) {
        const index = this.jobApplicantData.findIndex((i) => i.id === item.id);

        if (index !== -1) {
          this.$set(this.jobApplicantData[index], "short_listed", 0);
        }
        if (item.short_listed == 0) {
          if (this.removeToShortListData.includes(item.id)) {
            this.removeToShortListData = this.removeToShortListData.filter(
              (id) => id !== item.id,
            );
          } else {
            this.removeToShortListData.push(item.id);
          }
        } else {
          const index = this.removeToShortListData.indexOf(item.id);
          if (index > -1) {
            this.removeToShortListData.splice(index, 1);
          }
        }
        console.log("addedToShortListData", this.removeToShortListData);
      }
    },
    saveShortListed() {
      this.confirmSubmitShortListedDialog = true;
    },
    submitShortListed() {
      let dataToUpdate = [];
      if (this.tab == 1) {
        if (this.addedToShortListData.length > 0) {
          // this.addedToShortListData.push({ type: 1 });
          dataToUpdate.push({ data: this.addedToShortListData, type: 1 });
        }
      } else if (this.tab == 2) {
        if (this.removeToShortListData.length > 0) {
          dataToUpdate.push({ data: this.removeToShortListData, type: 2 });
        }
      }
      this.loadingState = true;
      this.axiosCall(
        "/job-applicant/updatedShortListed/" + JSON.stringify(dataToUpdate),
        "PATCH",
      ).then((res) => {
        if (res.data.status == 200) {
          setTimeout(() => {
            this.loadingState = false;
          }, 1500);
          this.initialize();
          this.confirmSubmitShortListedDialog = false;
          this.jobApplicantData = [];
          this.addedToShortListData = [];
          this.removeToShortListData = [];
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        } else if (res.data.status == 400) {
          setTimeout(() => {
            this.loadingState = false;
          }, 1500);
          this.confirmSubmitShortListedDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    hireApplicant(item) {
      this.axiosCall("/job-posting/findJobInHis/" + this.id, "GET").then(
        (res) => {
          // console.log(res.data);
          // console.log("Applicant---", item);
          if (res.data.applicant_number != 0) {
            this.confirmDialog = true;
            this.applicantFullname = item.fullname;
            this.applicantFullData = item;
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "This Job is already Filled Up!";
          }
        },
      );
    },
    confirmHiring() {
      // console.log("Confirm Applicant", this.applicantFullData.id);
      this.axiosCall(
        "/job-applicant/updatedHiringApplicant/" + this.applicantFullData.id,
        "PATCH",
      ).then((res) => {
        // console.log(res.data);
        if (res.data.status == 200) {
          this.axiosCall(
            "/job-posting/updatedNumberOfApplicant/" + this.id,
            "PATCH",
          ).then((res) => {
            this.dialog = false;
            this.closeD();
            this.confirmDialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message =
              res.data.msg + " " + this.applicantFullname;
            this.$refs.MyDesignationFormref.reset();
          });
        } else if (res.data.status == 400) {
          this.dialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    getJobPostId() {
      if (this.action == 1) {
        if (this.tab == 1) {
          this.axiosCall(
            "/job-applicant/getApplicantSpecificJob/" + this.id,
            "GET",
          ).then((res) => {
            this.jobApplicantData = res.data;
            this.jobApplicantData.forEach((item) =>
              this.countNumberOfAppliedPosition(item),
            );
          });
        } else if (this.tab == 2) {
          this.axiosCall(
            "/job-applicant/getApplicantSpecificJobHEAD/" + this.id,
            "GET",
          ).then((res) => {
            this.jobApplicantData = res.data;
            this.jobApplicantData.forEach((item) =>
              this.countNumberOfAppliedPosition(item),
            );
          });
        } else if (this.tab == 3) {
          this.axiosCall(
            "/job-applicant/getShortListedByHEAD/" + this.id,
            "GET",
          ).then((res) => {
            this.jobApplicantData = res.data;
            this.jobApplicantData.forEach((item) =>
              this.countNumberOfAppliedPosition(item),
            );
          });
        }
      } else {
        this.axiosCall(
          "/job-applicant/getHiredApplicant/" + this.id,
          "GET",
        ).then((res) => {
          // console.log("POSTED JOB", res.data);
          this.jobApplicantData = res.data;
        });
      }
    },

    initialize() {
      const header = this.header.find((item) => item.value === "short_listed");

      if (header) {
        header.text =
          this.tab === 2 ? "Remove from Shortlist" : "Add to Shortlist";
      }

      this.getJobPostId();
    },
    getSYItemText(item) {
      return `${item.syFrom} - ${item.syTo}`;
    },
    getPart(id) {
      let prt;
      for (let i = 0; i < this.tapTimeList.length; i++) {
        if (this.tapTimeList[i].id == id) {
          prt = this.tapTimeList[i].title;
        }
      }
      return prt;
    },

    computeDaylist() {
      let days = [];
      for (let i = 0; i < this.schedList.length; i++) {
        let el = this.schedList[i].workSched;
        for (let j = 0; j < el.length; j++) {
          days.push(el[j]);
        }
      }

      // setting disabled property
      if (days.length > 0) {
        for (let i = 0; i < days.length; i++) {
          for (let j = 0; j < this.dayList.length; j++) {
            let dayListName = this.dayList[j].name;
            if (days[i] == dayListName) {
              this.dayList[j].disabled = true;
            }
          }
        }
      } else {
        for (let i = 0; i < this.dayList.length; i++) {
          this.dayList[i].disabled = false;
        }
      }
    },

    closeSchedDialog() {
      this.$refs.schedDialogRef.resetValidation();
      this.schedDialog = false;
    },

    saveSched() {
      if (this.$refs.schedDialogRef.validate()) {
        if (this.schedTimeList.length > 0) {
          this.schedList.push({
            workSched: this.schedWfh,
            schedTimeList: this.schedTimeList,
            // timeIn: this.timePicker1,
            // timeOut: this.timePicker2,
          });
          this.schedTimeList = [];
          this.schedDialog = false;
          this.computeDaylist();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please add time schedule/s!";
        }
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill up all fields!";
      }
    },

    getUserType() {
      this.axiosCall("/user-type/getAllUsertype", "GET").then((res) => {
        if (res.data) {
          this.usertypeList = res.data;
        }
      });
    },
    closeD() {
      //closed
      this.eventHub.$emit("closeApplicantJobList", false);
      this.dialog = false;
      this.dialog2 = false;
      this.confirmDialog = false;
      this.show = false;
    },
    closeD1() {
      this.dialog2 = false;
    },
    addnew() {
      if (
        this.applicationletter &&
        this.pds &&
        this.eligibility &&
        this.tor &&
        this.employment &&
        this.seminars
      ) {
        const fd = new FormData();

        let letter = this.applicationletter;
        let pds = this.pds;
        let performance = this.performance;
        let eligibility = this.eligibility;
        let tor = this.tor;
        let employment = this.employment;
        let seminars = this.seminars;
        const arraaay = [
          letter,
          pds,
          performance,
          eligibility,
          tor,
          employment,
          seminars,
        ];
        // console.log("arraaay", arraaay);

        for (let i = 0; i < arraaay.length; i++) {
          const element = arraaay[i];
          fd.append("file", element);
        }
        // console.log(fd);

        let gender;
        if (this.gender == 0) {
          gender = "Male";
        } else {
          gender = "Female";
        }

        const data = {
          firstname: this.firstname,
          mi: this.mi,
          suffix: this.suffix,
          position: this.position,
          lastname: this.lastname,
          email: this.email,
          phone_number: this.phone,
          gender: gender,
          country: this.country,
          zip_code: this.zipcode,
        };
        // console.log(data);
        fd.append("body", JSON.stringify(data));
        // console.log("FD", fd);
        this.axiosCall("/job-applicant/multiple", "POST", fd).then((resp) => {
          this.dialog = false;
          // console.log(resp);
          if (resp.status == 201) {
            alert("Succesfully Added:", resp.data.mg);
          } else if (resp.status == 400) {
            alert("not okay");
          }
        });
      } else {
        alert("Please Fill in all data needed");
      }
    },
    countNumberOfAppliedPosition(item) {
      this.axiosCall(
        "/job-applicant/getApplicantListOfAppliedPositions/" +
          item.firstname +
          "/" +
          item.lastname +
          "/" +
          item.mi +
          "/" +
          item.birth +
          "/" +
          item.email,
        "GET",
      ).then((res) => {
        console.log("Full response:", res.data);
        this.$set(
          this.appliedCounts,
          item.id,
          res.data[0]?.countedApplied || 0,
        );
        this.$set(
          this.appliedPositionIDs,
          item.id,
          res.data[0]?.appliedPositionIDs || [],
        );
      });
    },
    viewListedPositions(item) {
      console.log("viewListedPositions", item);
      if (item.length > 1) {
        this.axiosCall(
          "/job-applicant/getApplicantPositionApplied/" + JSON.stringify(item),
          "GET",
        ).then((res) => {
          this.dialogPositions = true;
          this.positionsData = res.data;
          console.log("Full response:", res.data);
        });
      } else {
        // alert("This is the only position applied for.");
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "info";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message =
          "This is the only position applicant applied for.";
      }
    },
  },
};
</script>
